// Chip colours for order and subscription statuses: green done, amber needs doing, red failed.

const GREEN = 'bg-green-50 text-green-700';
const AMBER = 'bg-amber-50 text-amber-700';
const ORANGE = 'bg-orange-50 text-orange-700';
const RED = 'bg-red-50 text-red-700';
const VIOLET = 'bg-violet-50 text-violet-700';
const GREY = 'bg-gray-100 text-gray-900';

const STATUS_STYLE: Record<string, string> = {
  delivered: GREEN,
  fulfilled: GREEN,
  paid: GREEN,
  active: GREEN,
  pending: AMBER,
  unfulfilled: AMBER,
  attempted_delivery: AMBER,
  partially_fulfilled: AMBER,
  in_progress: AMBER,
  in_transit: AMBER,
  out_for_delivery: AMBER,
  confirmed: AMBER,
  open: AMBER,
  paused: AMBER,
  on_hold: ORANGE,
  not_delivered: RED,
  failed: RED,
  // Closed, but money moved, so it must not look like a cancel.
  refunded: VIOLET,
  partially_refunded: VIOLET,
  cancelled: RED,
  canceled: RED,
};

/** Any spelling a provider sends ("ON_HOLD", "on hold", "on-hold"); an unknown status is grey. */
export function statusStyle(status: string): string {
  return STATUS_STYLE[status.trim().toLowerCase().replace(/[\s-]+/g, '_')] ?? GREY;
}
